// A MultiSet is like a Set excepts it is able to store items more than once and is therefore able to count them.
export class MultiSet<T> {
  private map: Map<T, number> = new Map();

  add(value: T): void {
    this.map.set(value, (this.map.get(value) ?? 0) + 1);
  }

  delete(value: T): boolean {
    const count = this.map.get(value);
    if (count === undefined) return false;
    if (count > 1) {
      this.map.set(value, count - 1);
    } else {
      this.map.delete(value);
    }
    return true;
  }

  deleteAll(value: T): boolean {
    return this.map.delete(value);
  }

  clear() {
    this.map.clear();
  }

  count(value: T): number {
    return this.map.get(value) ?? 0;
  }

  has(value: T): boolean {
    return this.map.has(value);
  }

  [Symbol.iterator](): IterableIterator<T> {
    return this.map.keys();
  }

  get size(): number {
    return this.map.size;
  }
}
